import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StatusRequest = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPage = location.pathname;
  if (currentPage.includes("monitoring")) {
    return (
      <div className="grid grid-cols-2 font-BarlowCondensed font-thin">
        <div className="col-start-1 flex items-center">
          <div className="w-6 h-3 border rounded-md border-yellow-400 bg-yellow-400 mx-2"></div>
          <p className="mr-4 font-extralight">{t("status.pending")}</p>
        </div>
        <div className="col-start-2 flex items-center">
          <div className="w-6 h-3 border rounded-md border-red-500 bg-red-500 mx-2"></div>
          <p className="mr-4 font-extralight">{t("status.late")}</p>
        </div>
        <div className="col-start-1 flex items-center">
          <div className="w-6 h-3 border rounded-md border-blue-400 bg-blue-400 mx-2"></div>
          <p className="mr-4 font-extralight">{t("status.delivered")}</p>
        </div>
        <div className="col-start-2 flex items-center">
          <div className="w-6 h-3 border rounded-md border-filter-green  bg-filter-green mx-2"></div>
          <p className="font-extralight">{t("status.accepted")}</p>
        </div>
      </div>
    );
  } else if (currentPage.includes("/recoveryfile")) {
    return (
      <div className="flex items-center justify-center font-BarlowCondensed font-thin text-nxm-dark-gray">
        <div className="w-6 h-3 border rounded-md border-yellow-400 bg-yellow-400 mr-2"></div>
        <p className="mr-4 font-extralight ">{t("status.pending")}</p>
        <div className="w-6 h-3 border rounded-md border-red-500 bg-red-500 mr-2"></div>
        <p className="mr-4 font-extralight ">{t("status.late")}</p>
        <div className="w-6 h-3 border rounded-md border-blue-400 bg-blue-400 mr-2"></div>
        <p className="mr-4 font-extralight ">{t("status.delivered")}</p>
        <div className="w-6 h-3 border rounded-md border-green-400  bg-green-400 mr-2"></div>
        <p className="font-extralight ">{t("status.accepted")}</p>
      </div>
    );
  } else {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 font-BarlowCondensed text-xs font-thin text-grey-trio sm:text-sm lg:justify-end">
        <p className="w-full font-extralight italic sm:w-auto">{t("status.legend")} </p>
        <div className="flex items-center gap-1.5">
          <div className="h-2.5 w-5 rounded-md border border-yellow-400 bg-yellow-400 sm:h-3 sm:w-6"></div>
          <p className="font-extralight">{t("status.pending")}</p>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-2.5 w-5 rounded-md border border-red-500 bg-red-500 sm:h-3 sm:w-6"></div>
          <p className="font-extralight">{t("status.late")}</p>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-2.5 w-5 rounded-md border border-blue-400 bg-blue-400 sm:h-3 sm:w-6"></div>
          <p className="font-extralight">{t("status.delivered")}</p>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-2.5 w-5 rounded-md border border-green-400 bg-green-400 sm:h-3 sm:w-6"></div>
          <p className="font-extralight">{t("status.accepted")}</p>
        </div>
      </div>
    );
  }
};

export default StatusRequest;
